<video #video webkit-playsinline playsinline muted preload="metadata" class="{{ videoClass }}">
    <source [src]="videoSrc" type="video/mp4">
</video>
<img *ngIf="poster && !videoLoaded" alt="" src="{{ poster }}" class="absolute w-full h-full object-cover"
     @fadeOut/>
<ng-content></ng-content>
